import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import 'swiper/scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faChevronCircleRight } from '@fortawesome/free-solid-svg-icons';
import { HANDOFFSLIDE1, HANDOFFSLIDE2, HANDOFFSLIDE3 } from '../../assets';

export default function HandOff({handleClose}:{handleClose:Function}) {
    const [activeSlide, setActiveSlide] = useState<number>(0);
    const [swiper, setSwiper] = useState<any>(null);

    useEffect(() => {

        if(swiper!==null)
        swiper.slideTo(activeSlide);
    
    }, [activeSlide])
    

    const titleArr = [
        "Search for a \nshipper",
        "Select a \nshipper",
        "Send your \npackages & more "
    ]

    const subtitleArr = [
        "Choose the shipment type and search for the shipper ",
        "Select the best shipper of your choice and click on book now ",
        "Fill the details of the package and make the payment "
    ]

    return (
        <div className={"handoff-wrapper "+"handoff-slide"+activeSlide}>
            <div style={{display:'flex', flexDirection:'column', height:'100%'}}>
                <Swiper
                    pagination={false} allowTouchMove={false}
                    spaceBetween={5} slidesPerView={1}
                    onSlideChange={() => console.log('slide change')}
                    onSwiper={setSwiper}
                    style={{flex:1, width:'100%'}}
                >
                    <SwiperSlide style={{height:'100%',width:'100%', display:'flex', justifyContent:'center'}}>
                        <img src={HANDOFFSLIDE1} style={{objectFit: 'contain', height: '100%', width:'auto', margin:'auto'}}/>
                    </SwiperSlide>
                    <SwiperSlide style={{height:'100%',width:'100%', display:'flex', justifyContent:'center'}}>
                        <img src={HANDOFFSLIDE2} style={{objectFit: 'contain', height: '100%', width:'auto', margin:'auto'}}/>
                    </SwiperSlide>
                    <SwiperSlide style={{height:'100%',width:'100%', display:'flex', justifyContent:'center'}}>
                        <img src={HANDOFFSLIDE3} style={{objectFit: 'contain', height: '100%', width:'auto', margin:'auto'}}/>
                    </SwiperSlide>
                </Swiper>
                <div>
                    <div style={{display:'flex', justifyContent:'center', alignItems:'center', backgroundColor:'#000', opacity:0.6, height:'32px', width:'72px', borderRadius:'52px', fontSize:'12px', fontWeight:600}}>
                        Step {activeSlide+1}/3
                    </div>
                    <div style={{fontSize:'34px', fontWeight:700, whiteSpace:'pre-wrap'}}>
                        {titleArr[activeSlide]}
                    </div>
                    <div style={{fontSize:'16px', fontWeight:300}}>
                        {subtitleArr[activeSlide]}
                    </div>
                    <div style={{display:'flex', justifyContent:'space-between'}}>
                        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                            <div className={"handoff-pill "+(activeSlide===0?"active":"")}>&nbsp;</div>
                            <div className={"handoff-pill "+(activeSlide===1?"active":"")}>&nbsp;</div>
                            <div className={"handoff-pill "+(activeSlide===2?"active":"")}>&nbsp;</div>
                        </div>
                        <div>{
                            activeSlide===2?
                            <FontAwesomeIcon icon={faCheckCircle} style={{height:'60px', width:'60px', cursor:'pointer'}}
                                onMouseDown={e=>{e.preventDefault();handleClose();}}
                            />
                            :
                            <FontAwesomeIcon icon={faChevronCircleRight} style={{height:'60px', width:'60px', cursor:'pointer'}}
                                onMouseDown={e=>{e.preventDefault();setActiveSlide(activeSlide+1)}}
                            />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
